// context/AuthContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { setTokens, clearTokens } from "./AxiosInstance";
import { useLocation, useNavigate } from "react-router-dom";
import config from '../Configurations/APIConfig';
import apiService from "../Configurations/APIService";
import DefaultData from "../../CompanyData/DefaultData";

const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [landingData, setLandingData] = useState({});

  useEffect(() => {
    let isMounted = true;

    const tryRefresh = async () => {
      const skipPaths = ["/", "/login", "/unauthorized"];
      if (skipPaths.includes(location.pathname)) {
        if (isMounted) setLoading(false);
        return () => { };
      }

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token");

        const res = await apiService.post(config.REFRESH, { refreshToken }); // 🟢 Send in body
        const accessToken = res.accessToken;
        // 🔐 Store new tokens
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        //setTokens(accessToken);
        setTokens({
          accessToken: accessToken,
          refreshToken: refreshToken,
        });

        const profile = await apiService.getSingle(config.GETUSERPROFILE);
        if (isMounted) {
          setUser({
            id: profile.userId,
            cid: profile.companyId,
            bid: profile.branchId,
            role: profile.roleName,
            name: profile.name,
            email: profile.email,
            phoneNumber: profile.phoneNumber,
            currency: profile.currency,
            logo: profile.logo,
            brandName: profile.brandName,
            companyname: profile.companyName,
            companygstno: profile.companyGSTNo,
            companypancard: profile.companyPanCard,
            companyaddress: profile.companyAddress,
            planType: profile.planType,
            endDate: profile.endDate,
            isSupplierAPI: profile.isSupplierAPI,
            parentCompanyId: profile.parentCompanyId
          });
        }
        await GetLandingPage();
      } catch (err) {
        console.error("Token refresh failed:", err);
        if (isMounted) await logout();
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    if (!localStorage.getItem("refreshToken")) {
      setLoading(false);
      return;
    }
    tryRefresh();
    return () => {
      isMounted = false;
    };
  }, []);

  const login = async ({ accessToken, refreshToken }) => {
    if (!accessToken || !refreshToken) {
      console.error("Missing accessToken or refreshToken");
      return;
    }
    // 🔐 Store both tokens
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    //setTokens(accessToken);
    setTokens({
      accessToken: accessToken,
      refreshToken: refreshToken,
    });

    const profile = await apiService.getSingle(config.GETUSERPROFILE);
    setUser({
      id: profile.userId,
      cid: profile.companyId,
      bid: profile.branchId,
      role: profile.roleName,
      name: profile.name,
      email: profile.email,
      phoneNumber: profile.phoneNumber,
      currency: profile.currency,
      logo: profile.logo,
      brandName: profile.brandName,
      companyname: profile.companyName,
      companygstno: profile.companyGSTNo,
      companypancard: profile.companyPanCard,
      companyaddress: profile.companyAddress,
      planType: profile.planType,
      endDate: profile.endDate,
      isSupplierAPI: profile.isSupplierAPI,
      parentCompanyId: profile.parentCompanyId
    });
    await GetLandingPage();
    navigate("/flight/search");
  };
  const GetLandingPage = async () => {
    const landingResponse = await apiService.getAll(`${config.GETLANDINGBYCOMPANY}/${DefaultData?.DEFAULTCOMPANYID}`);
    if (landingResponse.data) {
      setLandingData(landingResponse.data[0]);
    }
  }

  const logout = async () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    clearTokens(); // Assuming this clears any axios headers
    setUser(null);
    navigate("/login", { replace: true });
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, landingData }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
